const dTok = localStorage.getItem('dTok');
const user_id_docusign = localStorage.getItem('user_id_docusign');

const state = { dTok: dTok, user_id_docusign: user_id_docusign }

const mutations = {
  changeToken(state, tok){
    state.dTok = tok
    localStorage.setItem('dTok', tok)
    location.href = "/dashboard";
  },

  changeUserId(state, user_id){
    state.user_id_docusign = user_id
    localStorage.setItem('user_id_docusign', user_id)
    location.reload();
  }
}

const actions = {
  setToken({ state, commit }, tok){
    commit('changeToken', tok)
  },

  setUserId({ state, commit }, user_id){
    commit('changeUserId', user_id)
  }
}

export const docusignToken = {
  namespaced: true,
  state,
  actions,
  mutations
};